export const LEARN_MORE_COPY = {
  welcome: 'Welcome to Polco!',
  headerMessage:
    'The poster of this survey requires you to provide an email address to respond to this survey.',
  login: 'Login',
  learnMore: 'Learn more',
  userWithAccount: 'Already have an account?',
};
